























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import {Getter, Action} from 'vuex-class'
import NavigationMenu from '@/components/NavigationMenu.vue'
import CopyrightFooter from '@/components/CopyrightFooter.vue'
import ModalAlertCargaOccurrence from '@/components/modals/ModalAlertCargaOccurrence.vue'
import ModalAlertCargaReturned from '@/components/modals/ModalAlertCargaReturned.vue'
import ModalAlertAlertaCarga from '@/components/modals/ModalAlertAlertaCarga.vue'
import ModalAlertMotoristaCancelamentoCarga from '@/components/modals/ModalAlertMotoristaCancelamentoCarga.vue'
import SentinelResponse from '@/model/response/SentinelResponse'
import Responsavel from '@/model/resource/Responsavel'
import {ID} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import UploadDados from '@/model/resource/UploadDados'

@Component({
  components: {
    NavigationMenu,
    ModalAlertCargaOccurrence,
    ModalAlertCargaReturned,
    ModalAlertAlertaCarga,
    ModalAlertMotoristaCancelamentoCarga,
    CopyrightFooter,
  },
})
export default class DefaultPanelLayout extends Vue {
  @Action('auth/auth') auth!: Function
  @Action('sentinel/start') startSentinel!: Function
  @Action('sentinel/shutdown') shutdownSentinel!: Function

  @Getter('idView') idView!: string
  @Getter('auth/responsavel') user!: Responsavel
  @Getter('sentinel/result') sentinelResult!: SentinelResponse

  authorized = false

  @Watch('sentinelResult', {deep: true})
  async sentinelResultEvent(result: SentinelResponse) {
    if (result.idsCargaOccurrence.length && this.user.receberNotificacoesCarga) {
      this.alert('alertCargaOccurrence', result.idsCargaOccurrence)
    }

    if (result.idsCargaReturned.length && this.user.receberNotificacoesCarga) {
      this.alert('alertCargaReturned', result.idsCargaReturned)
    }

    if (result.idsAlertaCarga.length && this.user.receberNotificacoesTrajeto) {
      this.alert('alertAlertaCarga', result.idsAlertaCarga)
    }

    if (result.idsMotoristaCancelamentoCarga.length && this.user.receberNotificacoesCarga) {
      this.alert('alertMotoristaCancelamentoCarga', result.idsMotoristaCancelamentoCarga)
    }

    if (result.idsRelatorioGeracao.length) {
      Helper.success('system.success.report')
    }

    if (result.idsImportCargas.length) {
      const id = result.idsImportCargas[result.idsImportCargas.length - 1]

      if (id) {
        const uploadDados = await new UploadDados().getUploadDados(id)
        const resp = uploadDados.data

        if (resp) {
          if (resp.mensagemErro) {
            Helper.error(this.$t('system.info.importDeliveryError', {val: resp.mensagemErro}) as string)
          } else {
            Helper.success('system.success.cargaLote')
          }
        }
      }
    }

    if (result.idsImportSLA.length) {
      const id = result.idsImportSLA[result.idsImportSLA.length - 1]
      if (id) {
        const uploadDados = await new UploadDados().getUploadDados(id)
        const resp = uploadDados.data

        if (resp) {
          if (resp.mensagemErro) {
            Helper.error(this.$t('system.info.importSlaError', {val: resp.mensagemErro}) as string)
          } else {
            Helper.success('system.success.sla')
          }
        }
      }
    }
  }

  async alert(modalName: string, ids: ID[]) {
    this.$modal.close(modalName)
    await Helper.sleep(500)
    this.$modal.open(modalName, ids)
    Helper.playAlert()
  }

  async mounted() {
    await this.auth('authenticate')
    if (!Helper.isSac() && !Helper.isRastreamento()) {
        this.startSentinel()
    }
    this.authorized = true
  }

  destroyed() {
    this.shutdownSentinel()
  }
}
